const initailState = {
  pcbData: [],
  loadings: false,
};

export function pcbOfferReducer(
  state = initailState,
  { type, payload }
) {
  switch (type) {
    case "GET_PCB_OFFER":
      return { ...state, pcbData: payload, loadings: false };
    case "PCB_OFFER_LOADING":
      return { ...state, loadings: true };
    case "PCB_OFFER_LOADDED":
      return { ...state, loadings: false };
    default:
      return state;
  }
}
